import { Column } from '../../../../hooks/useTablePages';
import { PlatformPlan } from './Plans.query';

const columns: Column[] = [
  {
    header: 'Name',
    accessor: 'name',
    width: 225,
  },
  {
    header: 'Description',
    accessor: 'description',
    width: 350,
  },
  {
    header: 'Products',
    id: 'products',
    accessor: (row: PlatformPlan) => row.products?.length || 0,
    width: 100,
  },
];

export default columns;
